import { render, staticRenderFns } from "./SearchText.vue?vue&type=template&id=3837c23c&scoped=true&"
import script from "./SearchText.vue?vue&type=script&lang=js&"
export * from "./SearchText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837c23c",
  null
  
)

export default component.exports